<template>
  <view-layout>
    <continue-action slot="action" v-if="!$context.is.desktop" />
    <zm-skeleton class="shopping-cart" slot="side" animated :rows="6" :loading="!ready">
      <shopping-cart
        :showTitle="$context.is.desktop"
        :filter-keys="draftPlanFilterKeys"
        @remove="(key, plan) => $refs.core.removePlanByCode(key, plan)"
      >
       <continue-action slot="action" v-if="$context.is.desktop" />
      </shopping-cart>
    </zm-skeleton>
    <div class="opc-config">
      <nav-cart-back
        class="opc-nav__cart-back"
        :visible="persistShoppingBagVisible"
        :back-content="$t('billing.common.cart_bag.continue_shopping_btn')"
        :back-handler="backHandler"
      />
      <div :class="`opc-config__title ${persistShoppingBagVisible ? 'opc-config__title-persist-cart' : ''}` ">
        <Nav />
      </div>
      <zm-skeleton animated :rows="10" :loading="!ready">
        <open-invoice-alert />
        <partner-refer />
        <BannerContainer />
        <core ref="core" :divider-text="enhanceTitle" :addonable="isAddonAllowed" />
        <ConfigDesc />
      </zm-skeleton>
    </div>
    <partner-promote />
  </view-layout>
</template>

<script>
import ViewLayout from "@/components/view-layout.vue";
import ViewLayoutMobile from "@/components/view-layout.m.vue";
import Nav from '@/components/nav.vue';
import ShoppingCart from './shopping-cart/index.vue';
import ContinueAction from './shopping-cart/continue.vue';
import Core from './core.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { planTypes } from '@/common/constants';
import log from '@/common/log';
import rpsMixins from '@/aspects/rps';
import PartnerRefer from '@/views/config/partner-refer/index';
import BannerContainer from '@/components/service/config-banner';
import ConfigDesc from '@/components/service/config-desc';
import {
  isZoneBundleContext,
  onlyPromotionZoneBundleForCampaign,
} from '@/plans/ZOOM_MEETING/common/utils';
import { $context } from '@/global-install';
import PartnerPromote from '@/views/succezz/components/partner-promote.vue';
import NavCartBack from '@/components/nav-cart-back.vue';
import persistShoppingBag, { persistCartConstant } from '@/views/config/shopping-cart/persist/persist-cart';
import { pageConfig } from '@/common/service/page-config';
import OpenInvoiceAlert from '@/views/config/shopping-cart/open-invoice/invoice-alert.vue';

export default {
  components: {
    OpenInvoiceAlert,
    NavCartBack,
    PartnerPromote,
    PartnerRefer,
    ViewLayout: $context.is.desktop ? ViewLayout : ViewLayoutMobile,
    ShoppingCart,
    ContinueAction,
    Core,
    Nav,
    BannerContainer,
    ConfigDesc,
  },
  data() {
    return {
      ready: false,
      persistShoppingBagVisible: persistCartConstant.enablePersistShoppingBag
    };
  },
  mixins: [rpsMixins],
  computed: {
    ...mapGetters(['getCurrentBasePlanInfo', 'getSelectedPlans', 'selectedSingleUsePro', 'draftPlanFilterKeys']),
    basePlanType() {
      return this.getCurrentBasePlanInfo.planType;
    },
    selectedTypes() {
      let types = [...new Set(this.getSelectedPlans.map((x) => x.type))];
      // HARDCODE
      if(isZoneBundleContext || onlyPromotionZoneBundleForCampaign(this.getSelectedPlans)) types = types.filter(x => x !== planTypes.ZOOM_PHONE);
      return types;
    },
    enhanceTitle() {
      if (this.basePlanType === planTypes.ZOOM_PHONE) {
        return 'Enhance Your Zoom Phone Experience';
      }
      return this.$t('billing.enhance_experience');
    },
    isAddonAllowed() {
      const editType = pageConfig?.editConfig?.planType;
      if (editType === planTypes.ZOOM_SCHEDULER && this.$context.is.buyTrial && pageConfig?.enableBaseWithFreeTrialCheckout) {
        return true
      }
      if(this.$context.is.buyTrial || this.$context.is.add2trial) return false;
      if (this.selectedSingleUsePro) return false;
      return true;
    },
  },
  methods: {
    ...mapActions(['initPageFlow']),
    ...mapMutations(['setDraftPlanFilterKeys']),
    backHandler() {
      return persistShoppingBag.continueShopping();
    },
    async init() {
      await this.initPageFlow();
      this.setDraftPlanFilterKeys(planTypes.map(this.selectedTypes.length ? this.selectedTypes : [this.basePlanType]))
      this.ready = true;
      this.$nextTick(() => {
        this.focusToConfig()
      });
    },
    focusToConfig() {
      const configPanels = document.getElementsByClassName('opc-foldable');
      const firstPanel = configPanels[0];
      if(!firstPanel) return;
      const inputs = firstPanel.getElementsByTagName('input');
      inputs[0] && inputs[0].focus();
    },
  },
  watch: {
    isAddonAllowed: {
      immediate: true,
      handler(is){
        log('config:addonable', is);
      }
    },

  },
  created() {
    this.init();

    this.$context.$on('update-draft-plan-keys', () => {
      this.$nextTick(() => {
        this.setDraftPlanFilterKeys(planTypes.map(this.selectedTypes.length ? this.selectedTypes : [this.basePlanType]))
      });
    });
  },
  mounted(){
    this.mx_asyncRpsBlock()
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';
.opc-config {
  width: 100%;
  &__title {
    margin-bottom: 48px;
    @include media(mobile,tablet){
      margin-bottom: $mobile-space;
    }
  }

  &__title-persist-cart {
    @include media(mobile,tablet) {
      display: none !important;
    }
  }
}
.config-desc-slot {
  color: var(--day-foreground-foreground-ada, #666487);
  /* Body/Body S */
  font-family: Almaden Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 21px */
}
</style>
